import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-threads-list-skeleton',
  templateUrl: './threads-list-skeleton.component.html',
  styleUrls: [
    '../treads-item/treads-item.component.scss',
    './threads-list-skeleton.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreadsListSkeletonComponent {}
